import { memo } from "react";
import { FormattedMessage } from "react-intl";

import { ActionTool } from "common/meeting/toolbar/tool";

type Props = {
  onClick: () => void;
};

function AddWitnessTool({ onClick }: Props) {
  return (
    <ActionTool
      onToggleActivate={onClick}
      label={
        <FormattedMessage
          id="7fafdde9-498d-4f05-bebc-09f465f963c7"
          defaultMessage="Add a Witness"
        />
      }
      iconName="name"
      tagName="div"
    />
  );
}

export default memo(AddWitnessTool);
